(function() {
  const modalWrapper = document.querySelector('.voo-modal-size-guide');
  const openModalBtns = document.querySelectorAll('.size-guide-modal');

  if (!modalWrapper || openModalBtns.length === 0) return;

  const modalContainer = modalWrapper.querySelector('.voo-modal-size-guide__container');
  const closeBtn = modalWrapper.querySelector('.voo-modal-size-guide__close-btn');

  openModalBtns.forEach((btn) => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      modalWrapper.style.visibility = 'visible';
      document.body.classList.add('overflow-hidden');
    });
  });

  if (!modalContainer || !closeBtn) return;

  modalWrapper.addEventListener('click', (e) => {
    const withinBoundaries = e.composedPath().includes(modalContainer);

    if (!withinBoundaries) {
      modalWrapper.style.visibility = 'hidden';
      document.body.classList.remove('overflow-hidden');
    }
  });
  
  closeBtn.addEventListener('click', () => {
    modalWrapper.style.visibility = 'hidden';
    document.body.classList.remove('overflow-hidden');
  });
})();
